import { BlockContainer } from "BaseComponents/Wrappers";
import React, { useState, useRef, useEffect } from "react";
import { H2 } from "BaseComponents/Text";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { PrimaryButton, ButtonText } from "Buttons";
import { useGlobal } from "reactn";
import { LinkBlock } from "./LinkBlock";

export const LinkBlockContainer = (model) => {
	const { LinkBlocks, BackgroundColor } = model;
	
	const LinkBlockWrapper = styled.div`
		margin: 0 auto;
		max-width: 1280px;

		${media.greaterThan(breakpoints.mobile)`
		margin: 0 -10px;
        flex-direction: row;
        `}
		flex-direction: column;

		display: flex;

		${media.lessThan(breakpoints.ipad)`
  /* padding: 1rem 1rem; */
  
  `}/* ${media.lessThan(breakpoints.mobile)`
  padding: 0 1rem;

  `} */
	`;
	return (
		<LinkBlockWrapper>
			{LinkBlocks.map((block, i) => {
				return <LinkBlock key={i} BackgroundColor={BackgroundColor} {...block} />;
			})}
		</LinkBlockWrapper>
	);
};
//
